module.exports = __webpack_public_path__ + "static/media/ball_4_2.cef3d908.mp3";